import ChatDialogs from './ChatDialogs';

export default ChatDialogs;
